import create from "zustand";
import moment from "moment";

export interface SoftwareFeatures {
  isManualSystemEnabled: boolean;
  isAutomaticSystemEnabled: boolean;
  isFlowRateSystemEnabled: boolean;
  isAssetDashboardEnabled: boolean;
  isHealthDashboardEnabled: boolean;
}

interface IAccountSettingsStore {
  accountTimezone: string;
  softwareFeatures: SoftwareFeatures | null;
  setAccountTimeZone: (timezone: string) => void;
  setSoftwareFeatures: (softwareFeatures: SoftwareFeatures | null) => void;
}

/**
 * This store allows us to access the current account settings anywhere in the application.
 */
export const useAccountSettingsStore = create<IAccountSettingsStore>((set) => ({
  accountTimezone: moment.tz?.guess(),
  softwareFeatures: null,
  setAccountTimeZone: (timezone: string) => {
    set((state) => {
      return {
        accountTimezone: timezone,
      };
    });
  },
  setSoftwareFeatures: (softwareFeatures: SoftwareFeatures | null) => {
    set((state) => {
      return {
        softwareFeatures: softwareFeatures,
      };
    });
  },
}));